import { RefundCreateWidget } from "@/widgets/refund/RefundCreateWidget";

export function RefundCreatePage() {
  return (
    <div className="page">
      <RefundCreateWidget />
    </div>
  );
}
